import React from "react";
import { Pause, PlayArrow, ArrowRight, ArrowLeft } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@material-ui/core";
import { formatTime } from "../utils/formatTime";
import LabelVideoStore from "store/labelVideoStore";
import { observer } from "mobx-react";

interface VideoControllerProps {
  isPlaying: boolean;
  onPlay: () => void;
  onPause: () => void;
  onFrameChange: (direction: number) => void;
  labelVideoStore: LabelVideoStore | undefined;
}

const VideoController: React.FC<VideoControllerProps> = ({
  isPlaying,
  onPlay,
  onPause,
  onFrameChange,
  labelVideoStore,
}) => {
  return (
    <div
      style={{
        display: "flex",
        padding: "8px",
        paddingBottom: "4px",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "0.875rem",
          color: "rgb(75, 85, 99)",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", width: "220px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "2px",
              paddingRight: "4px",
            }}
          >
            <span>Frame:</span>
            <span style={{ width: "fit-content" }}>{labelVideoStore?.currentFrame}</span>
            <span>/</span>
            <span style={{ minWidth: "fit-content" }}>{labelVideoStore?.totalFrames}</span>
            <span style={{ minWidth: "fit-content" }}>({labelVideoStore?.fps} fps)</span>
            <span>-</span>
            <span>
              {formatTime(labelVideoStore?.currentFrame || 0, labelVideoStore?.fps || 0)}
            </span>
          </div>
        </div>
      </div>

      <div>
        <Tooltip title="Revenir à l'image précédente ⬅">
          <IconButton onClick={() => onFrameChange(-1)} style={{ padding: "0px" }}>
            <ArrowLeft style={{ fontSize: "32px" }} />
          </IconButton>
        </Tooltip>
        {!isPlaying ? (
          <IconButton onClick={onPlay} style={{ padding: "4px" }}>
            <PlayArrow style={{ fontSize: "32px" }} />
          </IconButton>
        ) : (
          <IconButton onClick={onPause} style={{ padding: "4px" }}>
            <Pause style={{ fontSize: "32px" }} />
          </IconButton>
        )}
        <Tooltip title="Avancer d'une image ➡">
          <IconButton onClick={() => onFrameChange(1)} style={{ padding: "0px" }}>
            <ArrowRight style={{ fontSize: "32px" }} />
          </IconButton>
        </Tooltip>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "0.875rem",
          color: "rgb(75, 85, 99)",
        }}
      >
        <span>
          {formatTime(labelVideoStore?.totalFrames || 0, labelVideoStore?.fps || 0)}
        </span>
      </div>
    </div>
  );
};

export default observer(VideoController);
